import React from 'react'
import PropTypes from 'prop-types'
import { DefaultPlayer as Video } from 'react-html5video'
import 'react-html5video/dist/styles.css'


import Styles from '../index.scss'

const VideoPreview = props => (
  <div
    className={`${Styles[props.previewClassName]} text-center ${Styles['portfolio-item']} ${Styles[props.fullPage]}`}
    style={props.style}
  >
    <Video
      autoPlay={false}
      loop
      muted
      controls={['PlayPause', 'Seek', 'Time', 'Volume', 'Fullscreen']}
      poster={props.portfolio.url}
      onCanPlayThrough={() => {}}
      className={Styles[props.portfolio.orientation]}
      src={props.portfolio.urlRawFile}
    >
      <source src={props.portfolio.urlRawFile} type="video/mp4" />
    </Video>
  </div>
)

VideoPreview.defaultProps = {
  portfolio: {
    urlRawFile: '',
    url: '',
    orientation: '',
  },
  fullPage: '',
  previewClassName: '',
  controls: true,
  playing: false,
  volume: 0.8,
  style: {},
}

VideoPreview.propTypes = {
  portfolio: PropTypes.shape({
    url: PropTypes.string.isRequired,
    urlRawFile: PropTypes.string,
    orientation: PropTypes.string,
  }).isRequired,
  fullPage: PropTypes.string.isRequired,
  previewClassName: PropTypes.string,
  style: PropTypes.shape({}),
}

export default VideoPreview
